module.exports = __webpack_public_path__ + "img/php.e1c500ca.svg";